import { muiLicenseKey } from '../shared/muiLicenseKey';

disableMuiLicenseKeyError();

export function setMuiLicenseKey(): void {
  if (muiLicenseKey) {
    import('@mui/x-license').then(({ LicenseInfo }) => {
      LicenseInfo.setLicenseKey(muiLicenseKey);
    });
  }
}

function disableMuiLicenseKeyError(): void {
  if (import.meta.env.DEV) {
    // eslint-disable-next-line no-console
    const originalError = console.error.bind(console);
    // eslint-disable-next-line no-console
    console.error = (...args: any[]) => {
      const first = args[0];
      if (
        typeof first === 'string' &&
        first.includes('MUI X: Missing license key')
      ) {
        return;
      }
      originalError(...args);
    };
  }
}
